var ShopProfile = (function () {
    //var url = window.location.href;
    var url = "https://www.boxvilag.hu/";
    var popUpActive = true;
    var popUpname = '';
    var picName = '';
    var popUpdesc = '';
    var popUpLink = '';
    var getURLProfile = function () {
        return url;
    };
    //----> GET
    var getPopUpActiveProfile = function () {
        return popUpActive;
    }
    var getPopUpNameProfile = function () {
        return popUpname;
    };
    var getPopUpPicNameProfile = function () {
        return picName;
    };
    var getPopUpDescProfile = function () {
        return popUpdesc;
    };
    var getPopUpLinkProfile = function () {
        return popUpLink;
    };
    //---->
    var setPopUpActiveProfile = function (active) {
        popUpActive = active;
    }
    var setPopUpNameProfile = function (name) {
        popUpname = name;
    };
    var setPopUpPicNameProfile = function (name) {
        picName = name;
    };
    var setPopUpDescProfile = function (desc) {
        popUpdesc = desc;
    };    
    var setPopUpLinkProfile = function (link) {
        popUpLink = link;
    }
    return {
        getURL: getURLProfile,
        getPopUpActive: getPopUpActiveProfile,
        getPopUpName: getPopUpNameProfile,
        getPopUpPicName: getPopUpPicNameProfile,
        getPopUpDesc: getPopUpDescProfile,
        getPopUpLink: getPopUpLinkProfile,
        //---->
        setPopUpActive: setPopUpActiveProfile,
        setPopUpName: setPopUpNameProfile,
        setPopUpPicName: setPopUpPicNameProfile,
        setPopUpDesc: setPopUpDescProfile,
        setPopUpLink: setPopUpLinkProfile
    }
})();
export default ShopProfile;